<template>
  <router-view />
</template>
<script>
import M from 'materialize-css'

export default {
  name: 'App',
  data() {
            return {
                authenticated: false,
            }
          },
  components: {
  },
  mounted() {
    M.AutoInit()
  },
  methods: {}


}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>